<template>
	<div :class="['custom-switch', { 'custom-switch--sm' : sm }]">
		<v-switch
			v-model="value"
			inset
			hide-details
			flat
			:ripple="false"
			class="pt-0 mt-0"
		>
			<template v-slot:label>
				<div :class="['font-weight-bold grey--text text--darken-2', { 'font-12' : sm } ]">
					{{ label }}
				</div>
			</template>
		</v-switch>
	</div>

</template>

<script>
export default {
	name: "CustomSwitch",
	props: {
		label: {
			type: String,
			required: true
		},
		sm: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			value: true
		}
	},
	watch: {
		'$attrs.value': {
			handler(v) {
				this.value = v
			},
			immediate: true
		},
		'value': function (v) {
			this.$emit('input', v)
		}
	}
}
</script>

<style lang="scss">
.v-application--is-ltr .custom-switch .v-input--is-label-active.v-input--switch--inset.v-input--is-dirty .v-input--switch__thumb {
	transform: translate(14px, 0) !important;
}
.v-application--is-ltr .custom-switch--sm .v-input--is-label-active.v-input--switch--inset.v-input--is-dirty .v-input--switch__thumb {
	transform: translate(14px, 0) !important;
}
.custom-switch {
	&--sm {
		.v-input {
			&--is-label-active {
				.v-input--switch__thumb {
					transform: translate(14px, 0) !important;
				}
			}
			.v-input--selection-controls__input {
				height: 16px;
				width: 28px;
			}
			.v-input--switch__track {
				opacity: 1;
				background-color:  var(--v-grey-base);
				height: 16px;
				width: 28px;
				// left: 0;
				// top: calc(50% - 8px);
			}
			.v-input--switch__thumb {
				height: 12px;
				width: 12px;
				top: calc(50% - 6px);
				transform: translate(2px, 0) !important;
			}
		}
	}
	&:not(&--sm) {
		.v-input {
			&--is-label-active {
				.v-input--switch__thumb {
					// transform: translate(14px, 0) !important;
				}
			}
			.v-input--selection-controls__input {
				height: 16px;
				width: 32px;
			}
			.v-input--switch__track {
				height: 20px;
				width: 32px;
			}
			.v-input--switch__thumb {
				height: 16px;
				width: 16px;
				top: calc(50% - 8px);
				transform: translate(2px, 0) !important;
			}
		}
	}
	.v-input {
		.v-input--switch__track {
			opacity: 1;
			background-color:  var(--v-grey-base);
			top: 50%;
			transform: translateY(-50%);
			left: 0;
		}
		.v-input--switch__thumb {
			background-color:  white;
		}
		&--is-label-active {
			.v-input--switch__track {
				background-color:  var(--v-accent-base);
			}
			.v-input--switch__thumb {
				background-color:  white;
			}
		}
	}
}
</style>
